<!-- treatmentphilosopy -->
<div class="ttm-bgcolor-whiteecolor" *ngIf="section == 'TreatmentPhilosopy'">
  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">Treatment Philosopy</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container ttm-bgcolor-whiteecolor ">
    <!-- Treatment Philosophy Section -->
    <!-- <div class="row mt-4" style="background-color:#f7f9fa; padding: 30px 20px;">
      <p style="text-align: justify; font-size: 17px; line-height: 1.6; margin: auto; max-width: 90%;">
        The Treatment is based on the concept of <b>Panchamahabhootas</b>; Five elements of Nature: <b>Prithvi (Earth),
          Aap (Water), Tej (Fire), Vaayu (Air)</b> and <b>Aakash (Space)</b>.
      </p>
    </div>
    <section style="background-color: #ffffff; padding: 20px 10px;">
      <div style="max-width: 1000px; margin: auto;">
        <div style="display: flex; justify-content: center;">
          <ul style="text-align: left; font-size: 18px; color: #444; list-style-position: inside;">
            <li><b>Gaining a comprehensive understanding of the patient as a whole person</b></li>
            <li><b>Establishing common ground on treatment goals and options</b></li>
            <li><b>Integrating prevention and health promotion into care</b></li>
            <li><b>Maintaining a realistic and practical approach to care</b></li>
          </ul>
        </div>
      </div>
    </section> -->

    <div style="
        background-color: #f7f9fa;
        padding: 30px 20px;
        border-radius: 12px;
        box-shadow: 0 4px 12px rgba(0,0,0,0.08);
        margin: 10px auto;
      ">
      <p class="ml-5 mr-5" style="text-align: justify; font-size: 18px; line-height: 1.6; color: #333;">
        The Treatment is based on the concept of <b>Panchamahabhootas</b>; Five elements of Nature:
        <b>Prithvi (Earth), Aap (Water), Tej (Fire), Vaayu (Air)</b> and <b>Aakash (Space)</b>.
      </p>

      <div style="display: flex; justify-content: center;">
        <ul style="text-align: left; font-size: 18px; color: #444; list-style-position: inside;">
          <li><b>Gaining a comprehensive understanding of the patient as a whole person</b></li>
          <li><b>Establishing common ground on treatment goals and options</b></li>
          <li><b>Integrating prevention and health promotion into care</b></li>
          <li><b>Maintaining a realistic and practical approach to care</b></li>
        </ul>
      </div>
    </div>


    <!-- Naturopathy Section -->
    <div class="card-all mt-2">
      <div style="background-color:#f1f8f6; border-radius: 12px; padding: 40px 20px;">
        <h2 style="text-align:center; font-size: 26px; margin-bottom: 30px; color:#DC143C;">Naturopathy</h2>
        <div class="row" style="display: flex; flex-wrap: wrap; align-items: center;">
          <div class="col" style="flex: 1; padding: 20px;">
            <p style="text-align: justify; font-size: 16px; line-height: 1.6;">
              Naturopathy believes in a holistic approach towards a disease condition and treats the patient
              accordingly.
              Treatment is based on the principle of the Panchamahabhutas, recognizing the body as an integrated whole.
              Each element contributes uniquely:
            </p>
            <ul class="text-left" style="font-size: 16px; padding-left: 20px; line-height: 1.8;">
              <li><b>Earth (Prithvi):</b> Mud baths and mud packs to detoxify and revitalize the body.</li>
              <li><b>Water (Apas):</b> Hydrotherapy including baths, douches, packs, and compresses.</li>
              <li><b>Air (Vayu):</b> Breathing exercises and walking for mental clarity and oxygenation.</li>
              <li><b>Fire (Agni):</b> Sun and thermoleum baths to boost metabolism and circulation.</li>
              <li><b>Ether (Akasha):</b> Fasting therapy for balance, detox, and healing.</li>
            </ul>
          </div>
          <div class="col" style="flex: 1; padding: 20px; text-align: center;">
            <img src="assets/img/th2.jpeg" alt="Naturopathy"
              style="max-width: 100%; height: auto; border-radius: 10px; box-shadow: 0px 4px 10px rgba(0,0,0,0.1);">
          </div>
        </div>
      </div>
    </div>

    <!-- Diet Section -->
    <div class="card-all mt-2">
      <!-- background-color:#fff3e6 -->
      <div style="background-color:#f1f8f6; border-radius: 12px; padding: 40px 20px;">
        <h2 style="text-align:center; font-size: 26px; margin-bottom: 30px; color:#DC143C;">Diet</h2>
        <div class="row" style="display: flex; flex-wrap: wrap; align-items: center;">
          <div class="col" style="flex: 1; padding: 20px; text-align: center;">
            <img src="assets/img/th2.jpeg" alt="Diet"
              style="max-width: 100%; height: auto; border-radius: 10px; box-shadow: 0px 4px 10px rgba(0,0,0,0.1);">
          </div>
          <div class="col" style="flex: 1; padding: 20px;">
            <p style="text-align: justify; font-size: 16px; line-height: 1.6;">
              Diet plays an integral part in the Naturopathy treatment protocol. As Hippocrates said, <i>“Thy Food Shall
                Be Thy Medicine.”</i> Here, food is considered the main ingredient in the healing process.
            </p>
            <p style="text-align: justify; font-size: 16px; line-height: 1.6;">
              A simple, nutritious menu is designed based on individual health conditions. It includes herbal teas,
              juices, fresh fruits and vegetables, smoothies, soups, salads, sprouts, and millet-based meals. All food
              and
              drinks are served as per doctor's prescription.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Mud Therapy Section -->
    <div class="card-all mt-2">
      <div style="background-color:#f1f8f6; border-radius: 12px; padding: 40px 20px;">
        <h2 style="text-align:center; font-size: 26px; margin-bottom: 30px; color:#DC143C;">Mud Therapy</h2>
        <div style="display: flex; flex-wrap: wrap; align-items: center;">
          <div style="flex: 1; padding: 20px;">
            <p style="font-size: 16px; line-height: 1.6; text-align: justify;">
              Mud therapy represents the first element <b>“Earth”</b>. 6 feet deep mud purified through various
              processes
              is used for treatments.
              Natural minerals and salts present in the mud, along with its cooling effect, add to its therapeutic
              properties.
              It’s highly effective for skin conditions like <b>psoriasis, eczema, and dermatitis</b>. Mud applications
              also help reduce inflammation and relieve pain.
            </p>
          </div>
          <div style="flex: 1; padding: 20px; text-align: center;">
            <img src="assets/img/th3.jpeg" alt="Mud Therapy"
              style="max-width: 100%; border-radius: 10px; box-shadow: 0 4px 10px rgba(0,0,0,0.1);">
          </div>
        </div>
      </div>
    </div>

    <!-- Hydrotherapy Section -->
    <div class="card-all mt-2">
      <!-- background-color:#e7f3fc; -->
      <div style="background-color:#f1f8f6; border-radius: 12px; padding: 40px 20px;">
        <h2 style="text-align:center; font-size: 26px; margin-bottom: 10px; color:#DC143C;">Hydrotherapy</h2>
        <p style="text-align: center; font-size: 16px; margin-bottom: 30px;">
          This refers to the mode of therapy using water in different forms and temperatures.
        </p>
        <div style="display: flex; flex-wrap: wrap; align-items: center;">
          <div style="flex: 1; padding: 20px; text-align: center;">
            <img src="assets/img/th4.jpeg" alt="Hydrotherapy"
              style="max-width: 100%; border-radius: 10px; box-shadow: 0 4px 10px rgba(0,0,0,0.1);">
          </div>
          <div style="flex: 1; padding: 20px;">
            <h4 style="font-size: 18px; color:#1b5e8c;">Various Hydrotherapy treatments at Ashram:</h4>
            <div style="display: flex; flex-wrap: wrap; font-size: 16px; margin-top: 15px;">
              <div style="flex: 1; min-width: 150px; padding: 10px;">
                <ul class="text-left" style="padding-left: 15px;">
                  <li>Immersion Bath</li>
                  <li>Hip Bath</li>
                  <li>Jacuzzi Hip Bath</li>
                  <li>Spinal Spray</li>
                  <li>Vichy Shower</li>
                </ul>
              </div>
              <div style="flex: 1; min-width: 150px; padding: 10px;">
                <ul class="text-left" style="padding-left: 15px;">
                  <li>Circular Jet</li>
                  <li>Douche</li>
                  <li>Enema</li>
                  <li>Steam Bath</li>
                  <li>Arm & Foot Bath</li>
                  <li>Packs and Compress</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Massage Therapy Section -->
    <div class="card-all mt-2">
      <!-- background-color:#fff3e6; -->
      <div style="background-color:#f1f8f6; border-radius: 12px; padding: 40px 20px;">
        <h2 style="text-align:center; font-size: 26px; margin-bottom: 30px; color:#DC143C;">Massage Therapy</h2>
        <div style="display: flex; flex-wrap: wrap; align-items: center;">
          <div style="flex: 1; padding: 20px;">
            <p style="font-size: 16px; line-height: 1.6; text-align: justify;">
              Massage therapy involves manual manipulation of soft body tissues (muscles, tendons, ligaments, and
              connective tissue)
              to prevent and alleviate <b>pain, spasms, stress</b> and to promote overall health and wellness.
            </p>
            <p style="font-size: 16px; line-height: 1.6; text-align: justify;">
              <b>Sesame oil or coconut oil</b> is used depending on the sadhaka's condition. It is particularly useful
              for
              chronic pain and muscular relief.
            </p>
          </div>
          <div style="flex: 1; padding: 20px; text-align: center;">
            <img src="assets/img/th4.jpeg" alt="Massage Therapy"
              style="max-width: 100%; border-radius: 10px; box-shadow: 0 4px 10px rgba(0,0,0,0.1);">
          </div>
        </div>
      </div>
    </div>

    <div class="card-all mt-2">
      <!-- background-color:#f6faff; -->
      <div style="background-color:#f1f8f6; border-radius: 12px; padding: 40px 20px;">
        <h2 style="text-align:center; font-size: 26px; margin-bottom: 30px; color:#DC143C;">Yoga Therapy</h2>
        <div style="display: flex; flex-wrap: wrap; align-items: center;">
          <div style="flex: 1; padding: 20px; text-align: center;">
            <img src="assets/img/th5.jpeg" alt="Yoga Therapy"
              style="max-width: 100%; border-radius: 10px; box-shadow: 0 4px 10px rgba(0,0,0,0.1);">
          </div>
          <div style="flex: 1; padding: 20px;">
            <p style="font-size: 16px; line-height: 1.6; text-align: justify;">
              The word <b>Yoga</b> is derived from the Sanskrit word “Yuj” meaning union – union of body, mind, and
              soul.
              At the Ashram, yoga is practiced to harmonize these elements and bring about inner balance. We conduct
              three
              different yoga batches suited to varied age groups and health conditions.
            </p>
          </div>
        </div>
      </div>

      <div style="background-color:#ffffff; padding: 10px 20px;">
        <h3 style="text-align:center; color:#007acc;">Yoga Modules</h3>
        <div style="display:flex; flex-wrap: wrap; justify-content:center; margin-top:20px;">
          <button
            style="margin: 5px; padding: 10px 20px; background-color:#d9edf7; border:none; border-radius: 5px; font-weight: bold;">Yoga
            Asanas</button>
          <button
            style="margin: 5px; padding: 10px 20px; background-color:#d9edf7; border:none; border-radius: 5px; font-weight: bold;">Pranayamas</button>
          <button
            style="margin: 5px; padding: 10px 20px; background-color:#d9edf7; border:none; border-radius: 5px; font-weight: bold;">Meditation</button>
          <button
            style="margin: 5px; padding: 10px 20px; background-color:#d9edf7; border:none; border-radius: 5px; font-weight: bold;">Trataka</button>
          <button
            style="margin: 5px; padding: 10px 20px; background-color:#d9edf7; border:none; border-radius: 5px; font-weight: bold;">Shudhi
            Kriyas</button>
        </div>
        <div style="margin-top: 20px; text-align: center; font-size: 16px; color:#333;">
          <p><b>Yoga Asanas:</b> Postures combined with breathing to improve flexibility, strength, and balance.</p>
          <p><b>Pranayamas:</b> Breathing techniques to calm the mind, reduce stress, and boost focus.</p>
          <p><b>Meditation:</b> Daily sessions that bring inner clarity, peace, and healing.</p>
          <p><b>Trataka:</b> Yogic gazing technique that improves eye health and mental concentration.</p>
          <p><b>Shudhi Kriyas:</b> Internal body cleansing processes to detoxify and purify naturally.</p>
        </div>
      </div>
    </div>

    <div class="card-all mt-2">
      <!-- background-color:#f3f7ff; -->
      <div style="background-color:#f1f8f6; border-radius: 12px; padding: 40px 20px;">
        <h2 style="text-align:center; font-size: 24px; margin-bottom: 20px; color:#DC143C;">Physiotherapy</h2>
        <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 20px;">
          <div style="flex: 1; padding: 20px;">
            <p style="font-size: 15px; line-height: 1.5; text-align: justify; margin-bottom: 15px;">
              Physiotherapy is effective in treating musculoskeletal and neurological conditions such as arthritis,
              spondylosis, and chronic pain.
              It helps improve mobility and relieve stiffness through treatments like <b>IFT, TENS, SWD, Ultrasound,
                Traction, Wax Therapy</b> and <b>Exercise Therapy</b>.
            </p>
            <div style="display: flex; font-size: 15px; color: #2a2a2a;">
              <ul class="text-left" style="flex: 1; padding-left: 20px; margin: 0;">
                <li>IFT (Interferential Therapy)</li>
                <li>TENS</li>
                <li>SWD</li>
                <li>Ultrasound</li>
              </ul>
              <ul class="text-left" style="flex: 1; padding-left: 20px; margin: 0;">
                <li>Traction (Cervical & Lumbar)</li>
                <li>Wax Therapy</li>
                <li>Exercise Therapy</li>
              </ul>
            </div>
          </div>
          <div style="flex: 1; padding: 20px; text-align: center;">
            <img src="assets/img/th6.jpeg" alt="Physiotherapy"
              style="max-width: 100%; border-radius: 10px; box-shadow: 0 4px 10px rgba(0,0,0,0.1);">
          </div>
        </div>
      </div>
    </div>

    <!-- <div style="background-color: #f3f7ff; padding: 30px 20px;">
      <div style="
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 20px;
    transition: transform 0.3s ease;
  " onmouseover="this.style.transform='scale(1.02)'" onmouseout="this.style.transform='scale(1)'">
        <h2 style="text-align:center; font-size: 24px; margin-bottom: 20px; color:#2a4d88;">Physiotherapy</h2>
        <div style="display: flex; flex-wrap: wrap; align-items: center; gap: 20px;">
          <div style="flex: 1; text-align: center;">
            <img src="assets/img/th6.jpeg" alt="Physiotherapy"
              style="max-width: 100%; border-radius: 10px; box-shadow: 0 4px 10px rgba(0,0,0,0.1); max-height: 220px; object-fit: cover;">
          </div>

          <div style="flex: 1;">
            <p style="font-size: 15px; line-height: 1.5; text-align: justify; margin-bottom: 15px;">
              Physiotherapy is effective in treating musculoskeletal and neurological conditions such as arthritis,
              spondylosis, and chronic pain.
              It helps improve mobility and relieve stiffness through treatments like <b>IFT, TENS, SWD, Ultrasound,
                Traction, Wax Therapy</b> and <b>Exercise Therapy</b>.
            </p>
            <div style="display: flex; font-size: 15px; color: #2a2a2a;">
              <ul style="flex: 1; padding-left: 20px; margin: 0;">
                <li>IFT (Interferential Therapy)</li>
                <li>TENS</li>
                <li>SWD</li>
                <li>Ultrasound</li>
              </ul>
              <ul style="flex: 1; padding-left: 20px; margin: 0;">
                <li>Traction (Cervical & Lumbar)</li>
                <li>Wax Therapy</li>
                <li>Exercise Therapy</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="card-all mt-2">
      <!-- background-color:#fff9f4; -->
      <div style="background-color:#f1f8f6; border-radius: 12px; padding: 40px 20px;">
        <h2 style="text-align:center; font-size: 26px; margin-bottom: 30px; color:#DC143C;">Acupuncture</h2>
        <div style="display: flex; flex-wrap: wrap; align-items: center;">
          <div style="flex: 1; padding: 20px; text-align: center;">
            <img src="assets/img/th7.jpeg" alt="Acupuncture"
              style="max-width: 100%; border-radius: 10px; box-shadow: 0 4px 10px rgba(0,0,0,0.1);">
          </div>
          <div style="flex: 1; padding: 20px;">
            <p style="font-size: 16px; line-height: 1.6; text-align: justify;">
              Acupuncture is a <b>Traditional Chinese Medicine (TCM)</b> practice involving insertion of fine needles
              into
              specific points of the body.
              It restores the flow of energy (<b>Qi</b>) by removing blockages. This therapy effectively manages
              conditions like bronchial asthma, migraine, insomnia, spondylosis, arthritis, and fibromyalgia.
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row mt-4 ttm-bgcolor-whiteecolor">
      <p class="para-color  text-center mt-2"
        style="text-align:justify; display:inline-block; width:100%; text-align: center; text-align: justify; font-size: 16px;">
        The Treatment is based on the concept of Panchamahabhootas; Five elements of Nature: Prithvi (Earth),
        Aap (Water), Tej (Fire), Vaayu (Air) and Aakash (Space).</p>
    </div>
    <section class="ttm-bgcolor-whiteecolor clearfix">
      <div class="container">
        <div class="">
          <div class="featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-2">
            <div class="ttm-box-bottom-content ttm-bgcolor-whiteecolor">
              <div class="featured-desc ml-2" style="text-align:center;">
                <div class="text-center ml-5" style="font-size: 16px;">
                  <ul>
                    <p>Gaining a comprehensive understanding of the patient as a whole person</p>
                    <p>Establishing common ground on treatment goals and options</p>
                    <p>Integrating prevention and health promotion into care</p>
                    <p>Maintaining a realistic and practical approach to care</p>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="row mt-3 ml-4">
      <h1>Naturopathy</h1>
    </div>
    <div class="row mt-1">
      <section class="ttm-bgcolor-whiteecolor clearfix">
        <div class="container">
          <div class="row">
            <div
              class="col-lg-6 col-md-12 col-sm-12 featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-1">
              <div class="ttm-box-bottom-content mt-2 ttm-bgcolor-whiteecolor">
                <p class="text-align: center;">Naturopathy believes in holistic approach towards a disease condition and
                  treats </p>
                <div class="title text-left ml-4">
                  <div class="col-lg">
                    Treatment is based on the principle of the Panchamahabhutas (the five great elements), recognizing
                    the body as an integrated whole. Each element contributes uniquely to therapeutic practices:</div>
                </div>
                <div class="col-lg mt-3 mb-"></div>
                <div class="featured-desc ml-2" style="text-align:center;">
                  <div class="text-left ml-5" style="font-size: 16px;">
                    <a><b>Earth (Prithvi):</b> Utilized through mud baths and mud packs to detoxify and revitalize
                      the body.</a>
                    <br><a><b>Water (Apas):</b> Employed in hydrotherapy via baths, douches, packs, compresses, and
                      other water-based treatments to cleanse and invigorate.</a>
                    <br><a><b>Air (Vayu):</b> Incorporated through breathing exercises and outdoor walking to enhance
                      oxygenation and mental clarity.</a>
                    <br><a><b>Fire (Agni):</b> Engaged through sun baths and thermoleum baths to stimulate circulation
                      and metabolism.</a>
                    <br><a><b>Ether (Akasha):</b> Addressed through fasting therapy to promote inner balance,
                      detoxification, and healing.</a>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-lg-6 col-md-12 col-sm-12 featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-1 text-center ">
              <div class="ttm-box-bottom-content mt-2 ttm-bgcolor-whiteecolor">
                <div class="featured-icon">
                  <div
                    class="ttm-icon ttm-icon_element-fill ttm-icon_element-background-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                    <i class="flaticon flaticon-meditation"></i>
                  </div>
                </div>
                <img class="w-60 text-center img-fluid " src="assets/img/th2.jpeg" alt="First slide" width="400"
                  height="200">
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="row mt-3 ml-4">
      <h1>Diet</h1>
    </div>
    <div class="row mt-1">
      <section class="ttm-bgcolor-whiteecolor clearfix">
        <div class="container">
          <div class="row">
            <div
              class="col-lg-6 col-md-12 col-sm-12 featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-1 text-center ">
              <div class="ttm-box-bottom-content mt-2 ttm-bgcolor-whiteecolor">
                <div class="featured-icon">
                  <div
                    class="ttm-icon ttm-icon_element-fill ttm-icon_element-background-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                    <i class="flaticon flaticon-meditation"></i>
                  </div>
                </div>
                <img class="w-60 text-center img-fluid " src="assets/img/th2.jpeg" alt="First slide" width="400"
                  height="200">
              </div>
            </div>
            <div
              class="col-lg-6 col-md-12 col-sm-12 featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-1">
              <div class="ttm-box-bottom-content mt-2 ttm-bgcolor-whiteecolor">
                <div class="col-lg mt-3 mb-"></div>
                <div class="featured-desc ml-2" style="text-align:center;">
                  <div class="text-left ml-5" style="font-size: 16px;">
                    <p> Diet plays an integral part in Naturopathy treatment protocol. Hippocrates says “Thy Food Shall
                      Be Thy Medicine”. Here we consider food as the main ingredient in healing process.</p>
                    <p> A simple yet nutritious menu is designed to cater the need of the sadhakas depending on their
                      health issues. A variety of Herbal teas and juices, fruits and vegetable juices, smoothies, fresh
                      salads and sprouts, soups and millet based meal forms the core of our healthy meal menu. Food and
                      juices is served as prescribed by the Doctors.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div> -->
    <!-- Mud Therapy -->
    <!-- <div class="row mt-3">
      <section class="ttm-bgcolor-whiteecolor clearfix">
        <div class="container">
          <div class="row">
            <div class="col-lg-6 featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-2">
              <div class="ttm-box-bottom-content ttm-bgcolor-whiteecolor">
                <div class="title text-left ml-4">
                  <div class="col-lg"></div>
                  <h1>Mud Therapy</h1>
                </div>
                <div class="featured-desc ml-2" style="text-align:center;">
                  <div class="text-left ml-3" style="font-size: 16px;">
                    <p>Mud therapy represents the first element “Earth”. 6 feet deep mud which is purified through
                      various processes is used in treatments. Natural minerals and salt present in mud along with its
                      cooling effect adds to its therapeutic property. It’s extremely helpful in various condition of
                      the skin like psoriasis, eczema, dermatitis etc. Mud applications are also helpful in reducing
                      inflammation and relieving pain.</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-lg-6 col-md-12 col-sm-12 featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-5 text-center mt-2">
              <div class="ttm-box-bottom-content ttm-bgcolor-whiteecolor">
                <div class="featured-icon">
                  <div
                    class="ttm-icon ttm-icon_element-fill ttm-icon_element-background-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                    <i class="flaticon flaticon-meditation"></i>
                  </div>
                </div>
                <img class="w-60 text-center img-fluid " src="assets/img/th3.jpeg" alt="First slide" width="400"
                  height="200">
              </div>
            </div>
          </div>
        </div>
      </section>
    </div> -->
    <!-- Hydrotherapy -->
    <!-- <div class="mt-3">
      <div class="row mt-3 ml-4">
        <h1>Hydrotherapy</h1>
      </div>
      <div class="mt-1">
        <p class="text-left ml-3">This refers to the mode of therapy using water in different forms and
          temperature.</p>
        <section class="ttm-bgcolor-whiteecolor clearfix">
          <div class="container">
            <div class="row">
              <div class="col-lg-6 featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-2">
                <div class="ttm-box-bottom-content ttm-bgcolor-whiteecolor ml-3">
                  <div class="featured-icon">
                    <div
                      class="ttm-icon ttm-icon_element-fill ttm-icon_element-background-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                      <i class="flaticon flaticon-meditation"></i>
                    </div>
                  </div>
                  <img class="w-60 text-center img-fluid " src="assets/img/th4.jpeg" alt="First slide" width="400"
                    height="200">
                </div>
              </div>
              <div class="col-lg-6 featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-2">
                <div class="ttm-box-bottom-content ttm-bgcolor-whiteecolor">
                  <div class="title text-left ml-4">
                    <a class="font-size:18px ml-5">Various Hydrotherapy treatments at Ashram are:</a>
                  </div>
                  <div class="row mt-4" style="font-size: 16px;">
                    <div class="text-center col-md-4 ml-5">
                      <a>Immersion Bath</a>
                      <br><a>Hip Bath</a>
                      <br><a>Jacuzzi Hip Bath</a>
                      <br><a>Spinal Spray</a>
                      <br><a>Vichy Shower</a>
                    </div>
                    <div class="text-center col-md-4 mr-5">
                      <a>Circular Jet</a>
                      <br><a>Douche</a>
                      <br><a>Enema</a>
                      <br><a>Steam Bath</a>
                      <br><a>Arm and Foot Bath</a>
                      <br><a>Packs and compress</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div> -->
    <!-- <div class="mt-3">
      <div class="mt-1">
        <section class="ttm-bgcolor-whiteecolor clearfix">
          <div class="container">
            <div class="row">
              <div class="col-md-6 ttm-box-bottom-content ttm-bgcolor-whiteecolor">
                <div class="title text-left ml-4">
                  <div class="col-lg"></div>
                  <h1>Massage Therapy</h1>
                </div>
                <div class="featured-desc ml-2" style="text-align:center;">
                  <div class="text-left ml-3" style="font-size: 16px;">
                    <p>Massage therapy is manual manipulation of soft body tissues (muscle, connective
                      tissue, tendons and ligaments) to prevent and alleviate pain, discomfort, muscle
                      spasm, stress, and to promote health and wellness.</p>
                    <p> Sesame oil or coconut oil is used for massage which is particularly useful for
                      chronic pain depending on the condition of the sadhaka. </p>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-2">
                <div class="ttm-box-bottom-content ttm-bgcolor-whiteecolor ml-3">
                  <div class="featured-icon">
                    <div
                      class="ttm-icon ttm-icon_element-fill ttm-icon_element-background-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                      <i class="flaticon flaticon-meditation"></i>
                    </div>
                  </div>
                  <img class="w-60 text-center img-fluid " src="assets/img/th4.jpeg" alt="First slide" width="400"
                    height="200">
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div> -->
    <!-- Yoga Therapy -->
    <!-- <div class="row">
      <section class="ttm-bgcolor-whiteecolor clearfix">
        <div class="container">
          <div class="row">
            <div
              class="col-lg-6 col-md-12 col-sm-12 featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-5">
              <div class="ttm-box-bottom-content ttm-bgcolor-whiteecolor">
                <div class="title text-left ml-4">
                  <div class="col-lg"></div>
                  <h1>Yoga Therapy</h1>
                </div>
                <div class="featured-desc ml-2 mt-3" style="text-align:center;">
                  <div class="text-left ml-3" style="font-size: 16px;">
                    <p>The word Yoga is derived from the Sanskrit word “Yuj” which means union; Union of body, mind and
                      soul.</p>
                    <p> Here at Ashram we use this power of yoga to bring a balance between the mind and the body. We
                      have 3 batches of Yoga that caters to different age group and disease conditions. </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-lg-6 col-md-12 col-sm-12 featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-3 text-center ">
              <div class="ttm-box-bottom-content mt-5 ttm-bgcolor-whiteecolor">
                <div class="featured-icon">
                  <div
                    class="ttm-icon ttm-icon_element-fill ttm-icon_element-background-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                    <i class="flaticon flaticon-meditation"></i>
                  </div>
                </div>
                <img class="w-60 text-center img-fluid " src="assets/img/th5.jpeg" alt="First slide" width="400"
                  height="200">
              </div>
            </div>
          </div>
        </div>
      </section>
    </div> -->
    <!-- <div class="row mt-4">
      <div class="col-lg">
        <ul class="nav nav-pills border-bottom" id="pills-tab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="pills-netb-tab" data-toggle="pill" href="#p" role="tab"
              aria-controls="pills-netb" aria-selected="false">
              <h3>Yoga Asanas</h3>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="pills-netb-tab" data-toggle="pill" href="#Pranayamas" role="tab"
              aria-controls="pills-netb" aria-selected="false">
              <h3>Pranayamas</h3>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="pills-netb-tab" data-toggle="pill" href="#Meditation" role="tab"
              aria-controls="pills-netb" aria-selected="false">
              <h3>Meditation</h3>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="pills-netb-tab" data-toggle="pill" href="#Trataka" role="tab"
              aria-controls="pills-netb" aria-selected="false">
              <h3>Trataka</h3>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="pills-netb-tab" data-toggle="pill" href="#Shudhi" role="tab"
              aria-controls="pills-netb" aria-selected="false">
              <h3>Shudhi Kriyas</h3>
            </a>
          </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade show active" id="p" role="tabpanel" aria-labelledby="pills-netb-tab">
            <div class="payment-banner py-5 bg-light text-center">
              <h3>These are specific yogic postures done along with certain breath work to improve the
                strength, flexibility, agility and balance in the body and mind.</h3>
            </div>
          </div>
          <div class="tab-pane fade" id="Pranayamas" role="tabpanel" aria-labelledby="pills-netb-tab">
            <div class="payment-banner py-5 bg-light text-center text-left">
              <h3>Pranayama refers to a set of breathing techniques which helps to achieve desirable
                benefits. This helps in calming down to mind, to bring steadiness in thoughts and
                action and also has immense benefits in physical body.
              </h3>
            </div>
          </div>
          <div class="tab-pane fade" id="Meditation" role="tabpanel" aria-labelledby="pills-netb-tab">
            <div class="payment-banner py-5 bg-light text-center text-left">
              <h3>Meditation or dhyana helps in reducing stress, calming down the mind and bring
                clarity in thoughts and action. When the mind becomes free from agitation, calm and
                serene and at peace, meditation happens. A calm mind, good concentration, clarity of
                mind, improvement in communication, blossoming of skills and talents, an unshakeable
                inner strength, healing, the ability to connect to an inner source of energy,
                relaxation, and rejuvenation are all natural results of meditation
                At Ashram we have daily meditation sessions.
              </h3>
            </div>
          </div>
          <div class="tab-pane fade" id="Trataka" role="tabpanel" aria-labelledby="pills-netb-tab">
            <div class="payment-banner py-5 bg-light text-center text-left">
              <h3>Trataka is a kriya with multiple benefits. Traditionally, it has been practiced by
                Yogis in different ways not only for its beneficial effects on the eyes but also for
                its tremendous effect on improving concentration.
              </h3>
            </div>
          </div>
          <div class="tab-pane fade" id="Shudhi" role="tabpanel" aria-labelledby="pills-netb-tab">
            <div class="payment-banner py-5 bg-light text-center text-left">
              <h3>Shudhi Kriyas are cleansing and detoxifying process of the body through various
                procedures. Daily sessions on Shudhi Kriyas are conducted at Ashram depending on the
                need of the Sadhakas.</h3>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Physiotherapy -->
    <!-- <div class="row mt-4">
      <h1 class="text-left ml-3">
        Physiotherapy </h1>
      <section class="ttm-bgcolor-whiteecolor clearfix">
        <div class="container">
          <div class="row">
            <div class="featured-imagebox featured-imagebox-service ttm-box-view-top-image text-center">
              <div class="ttm-box-bottom-content mt-3 ttm-bgcolor-whiteecolor ml-3">
                <div class="featured-icon">
                  <div
                    class="ttm-icon ttm-icon_element-fill ttm-icon_element-background-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                    <i class="flaticon flaticon-meditation"></i>
                  </div>
                </div>
                <img class="w-60 text-center img-fluid " src="assets/img/th6.jpeg" alt="First slide" width="400"
                  height="200">
              </div>
            </div>
            <div class="featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-3">
              <div class="ttm-box-bottom-content ttm-bgcolor-whiteecolor">
                <div class="col-lg mb-"></div>
                <div class="featured-desc ml-2" style="text-align:center;">
                  <div class="text-left ml-5" style="font-size: 16px;">
                    <p>Physiotherapy treatments are very beneficial in treating various musculoskeletal and neurological
                      disorders. It is capable of treating various diseases like different kind of arthritis,
                      Spondylosis, painful conditions etc. Its ability to improve mobility and range of motion of
                      patients in various conditions is widely recognised. Various Physiotherapy treatments like IFT
                      (Interferential Therapy):, TENS (Transcutaneous Electrical Nerve Stimulation), SWD (Short Wave
                      Diathermy) ,Ultra Sound, Traction-Cervical and Lumbar, Wax Therapy and Exercise Therapy are
                      administered at Ashram. </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="row mt-5">
      <div class="col-lg">
        <ul class="nav nav-pills border-bottom text-left" id="pills-tab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="pills-credit-tab" data-toggle="pill" href="#IFT" role="tab"
              aria-controls="pills-credit" aria-selected="true">
              <h3>IFT <br>(Interferential Therapy)</h3>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="pills-netb-tab" data-toggle="pill" href="#TENS" role="tab"
              aria-controls="pills-netb" aria-selected="false">
              <h3>TENS <br>(Transcutaneous Electrical<br> Nerve
                Stimulation)</h3>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="pills-netb-tab" data-toggle="pill" href="#SWD" role="tab" aria-controls="pills-netb"
              aria-selected="false">
              <h3>SWD <br>
                (Short Wave Diathermy)</h3>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="pills-netb-tab" data-toggle="pill" href="#Ultra" role="tab"
              aria-controls="pills-netb" aria-selected="false">
              <h3>Ultra Sound</h3>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="pills-netb-tab" data-toggle="pill" href="#Traction" role="tab"
              aria-controls="pills-netb" aria-selected="false">
              <h3>Traction-Cervical <br>
                and Lumbar</h3>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="pills-netb-tab" data-toggle="pill" href="#Wax" role="tab" aria-controls="pills-netb"
              aria-selected="false">
              <h3>Wax Therapy</h3>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="pills-netb-tab" data-toggle="pill" href="#Exercise" role="tab"
              aria-controls="pills-netb" aria-selected="false">
              <h3>Exercise Therapy</h3>
            </a>
          </li>
        </ul>
        <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade show active" id="IFT" role="tabpanel" aria-labelledby="pills-credit-tab">
            <div class="payment-banner py-5 bg-light text-center">
              <h3>Interferential therapy is a physiotherapy treatment through electrical signals with a
                mild frequency. This penetrates through your skin to stimulate and activate the function
                of tissues and muscles at large.This therapy helps in relieving pain, stiffness and
                accelerates healing process.</h3>
            </div>
          </div>
          <div class="tab-pane fade" id="TENS" role="tabpanel" aria-labelledby="pills-netb-tab">
            <div class="payment-banner py-5 bg-light text-center">
              <h3>Tens therapy is helpful for the activation and stimulation of the nerve through a low
                voltage electric current thereby helping in painful conditions.</h3>
            </div>
          </div>
          <div class="tab-pane fade" id="SWD" role="tabpanel" aria-labelledby="pills-netb-tab">
            <div class="payment-banner py-5 bg-light text-center text-left">
              <h3>Shortwave diathermy is localised deep heat physiotherapy through electromagnetic waves,
                which is helpful in different kinds of muscular disorders. It is helpful in relieving
                pain and stiffness.
              </h3>
            </div>
          </div>
          <div class="tab-pane fade" id="Ultra" role="tabpanel" aria-labelledby="pills-netb-tab">
            <div class="payment-banner py-5 bg-light text-center text-left">
              <h3>Ultrasound therapy is a physiotherapy treatment modality that uses deep heating waves
                for localized pain which affects muscles, tendons, joints, and ligaments. USD therapy
                gives best results in chronic inflammation and provides relief from pain and stiffness.
              </h3>
            </div>
          </div>
          <div class="tab-pane fade" id="Traction" role="tabpanel" aria-labelledby="pills-netb-tab">
            <div class="payment-banner py-5 bg-light text-center text-left">
              <h3>Traction is a decompression physiotherapy modality that relieves pressure on particular
                nerve. Helpful in painful conditions of back and neck with nerve impingement.
              </h3>
            </div>
          </div>
          <div class="tab-pane fade" id="Wax" role="tabpanel" aria-labelledby="pills-netb-tab">
            <div class="payment-banner py-5 bg-light text-center text-left">
              <h3>Wax therapy is a form of heat therapy, one of the most effective ways of applying heat
                to improve mobility by warming the connective tissues. Wax Therapy, involves the
                application of molten paraffin wax, to the connecting tissues causing muscle relaxation
                and improves joint mobility.</h3>
            </div>
          </div>
          <div class="tab-pane fade" id="Exercise" role="tabpanel" aria-labelledby="pills-netb-tab">
            <div class="payment-banner py-5 bg-light text-center text-left">
              <div class="text-left ml-4">
                <p><i class="fa fa-check"></i> Shoulder Wheel Exerciser </p>
                <p><i class="fa fa-check"></i> Quadriceps Table Exerciser </p>
                <p><i class="fa fa-check"></i> Finger Ladder Exerciser </p>
                <p> <i class="fa fa-check"></i>Hand Grip strength Exerciser </p>
                <p> <i class="fa fa-check"></i>Ankle Exerciser </p>
                <p> <i class="fa fa-check"></i> Pulley Exerciser </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- Acupuncture -->
    <!-- <div class="row mt-3">
      <section class="ttm-bgcolor-whiteecolor clearfix">
        <div class="container">
          <div class="row">
            <div class="featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-3">
              <div class="ttm-box-bottom-content ttm-bgcolor-whiteecolor">
                <div class="title text-left ml-4">
                  <div class="col-lg"></div>
                  <h1>Acupuncture</h1>
                </div>
                <div class="featured-desc ml-2" style="text-align:center;">
                  <div class="text-left ml-3" style="font-size: 16px;">
                    <p>Acupuncture is a traditional Chinese system (TCM) of medicine where fine needles are inserted in
                      various parts of the body depending on the disease conditions. TCM believes in the flow of energy
                      (Qi) throughout the body via various channels and any blockages in this energy flow leads to
                      diseases. Acupuncture helps in clearing these blockages thereby allowing the normal flow of Qi.
                      Various disease conditions like bronchial asthma, migraine, insomnia, spondylosis, arthritis,
                      fibromyalgia etc can be managed very well through acupuncture.</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="featured-imagebox featured-imagebox-service ttm-box-view-top-image mt-3 text-center ">
              <div class="ttm-box-bottom-content ttm-bgcolor-whiteecolor ml-4">
                <div class="featured-icon">
                  <div
                    class="ttm-icon ttm-icon_element-fill ttm-icon_element-background-color-skincolor ttm-icon_element-size-md ttm-icon_element-style-rounded">
                    <i class="flaticon flaticon-meditation"></i>
                  </div>
                </div>
                <img class="w-60 text-center img-fluid " src="assets/img/th7.jpeg" alt="First slide" width="400"
                  height="200">
              </div>
            </div>
          </div>
        </div>
      </section>
    </div> -->
  </div>
  <!-- <div class="col-lg mt-5"></div> -->
</div>
<!-- treatment -->
<div class="ttm-bgcolor-whiteecolor" *ngIf="section == 'Treatments'">
  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">Conditions Treated</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container ttm-bgcolor-whiteecolor text-center mt-4">
    <div class="ttm-bgcolor-whiteecolor">
      <div class="accordion-wrapper">
        <div class="">
          <div class="col-xl">
            <div class="mb-4" id="accordion-5" role="tablist" aria-multiselectable="true">
              <div class="accordion-with-arrow">
                <div class="card border-primary">
                  <div class="card-header" role="tab" style="background-color: #366b36b8;" id="heading-13">
                    <h5 class="mb-0">
                      <a class="accordion-toggle text-left text-white" data-toggle="collapse" data-target="#collapse-13"
                        aria-expanded="true" aria-controls="collapse-13">
                        Musculoskeletal Disorders
                      </a>
                    </h5>
                  </div>
                  <div id="collapse-13" class="collapse show" role="tabpanel" aria-labelledby="heading-13"
                    data-parent="#accordion-5">
                    <div class="card-body">
                      <div class="text-left">
                        <a>Osteoarthritis</a>
                        <br><a>Rheumatoid Arthritis</a>
                        <br><a>Gout</a>
                        <br><a>Cervical Spondylosis</a>
                        <br><a>Lumbar Spondylosis</a>
                        <br><a>Calcaneal spur</a>
                        <br><a>Fibromyalgia</a>
                        <br><a>Chronic fatigue syndrome</a>
                        <br><a>Ankylosing spondylosis</a>
                        <br><a>Frozen shoulder</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card border-primary">
                  <div class="card-header" role="tab" style="background-color: #366b36b8;" id="heading-14">
                    <h5 class="mb-0">
                      <a class="collapsed accordion-toggle text-left text-white" data-toggle="collapse"
                        data-target="#collapse-14" aria-expanded="false" aria-controls="collapse-14">
                        Gastrointestinal Disorders
                      </a>
                    </h5>
                  </div>
                  <div id="collapse-14" class="collapse" role="tabpanel" aria-labelledby="heading-14"
                    data-parent="#accordion-5">
                    <div class="card-body">
                      <div class="text-left">
                        <a>Constipation</a>
                        <br><a>Hyperacidity</a>
                        <br><a>Gastritis</a>
                        <br><a>GERD</a>
                        <br><a>Coatis</a>
                        <br><a>IBS</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card border-primary">
                  <div class="card-header" role="tab" style="background-color: #366b36b8;" id="heading-15">
                    <h5 class="mb-0">
                      <a class="collapsed accordion-toggle text-left text-white" data-toggle="collapse"
                        data-target="#collapse-15" aria-expanded="false" aria-controls="collapse-15">
                        Respiratory Disorders
                      </a>
                    </h5>
                  </div>
                  <div id="collapse-15" class="collapse" role="tabpanel" aria-labelledby="heading-15"
                    data-parent="#accordion-5">
                    <div class="card-body">
                      <div class="text-left">
                        <a>Bronchial Asthma</a>
                        <br><a>Allergic Asthma</a>
                        <br><a>Bronchitis</a>
                        <br><a>Sinusitis</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card border-primary">
                  <div class="card-header" role="tab" style="background-color: #366b36b8;" id="heading-16">
                    <h5 class="mb-0">
                      <a class="collapsed accordion-toggle text-left text-white" data-toggle="collapse"
                        data-target="#collapse-16" aria-expanded="false" aria-controls="collapse-16">
                        Endocrine Disorders
                      </a>
                    </h5>
                  </div>
                  <div id="collapse-16" class="collapse" role="tabpanel" aria-labelledby="heading-16"
                    data-parent="#accordion-5">
                    <div class="card-body">
                      <div class="text-left">
                        <a>Obesity</a>
                        <br><a>Hypothyroidism</a>
                        <br><a>Hyperthyroidism</a>
                        <br><a>Type2 Diabetes Mellitus</a>
                        <br><a>PCOD</a>
                        <br><a>PCOS</a>
                        <br><a>Infertility</a>
                        <br><a>Menstrual Disorders</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card border-primary">
                  <div class="card-header" role="tab" style="background-color: #366b36b8;" id="heading-17">
                    <h5 class="mb-0">
                      <a class="collapsed accordion-toggle text-left text-white" data-toggle="collapse"
                        data-target="#collapse-17" aria-expanded="false" aria-controls="collapse-17">
                        Disorders of Skin
                      </a>
                    </h5>
                  </div>
                  <div id="collapse-17" class="collapse" role="tabpanel" aria-labelledby="heading-17"
                    data-parent="#accordion-5">
                    <div class="card-body">
                      <div class="text-left">
                        <br><a>Psoriasis</a>
                        <br><a>Dermatitis</a>
                        <br><a>Eczema</a>
                        <br><a>Acne</a>
                        <br><a>Skin allergies</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card border-primary">
                  <div class="card-header" role="tab" style="background-color: #366b36b8;" id="heading-18">
                    <h5 class="mb-0">
                      <a class="collapsed accordion-toggle text-left text-white" data-toggle="collapse"
                        data-target="#collapse-18" aria-expanded="false" aria-controls="collapse-18">
                        Cardiovascular Disorders
                      </a>
                    </h5>
                  </div>
                  <div id="collapse-18" class="collapse" role="tabpanel" aria-labelledby="heading-18"
                    data-parent="#accordion-5">
                    <div class="card-body">
                      <div class="text-left">

                        <br><a>Hypertension</a>
                        <br><a>Hypotension</a>
                        <br><a>Dyslipidemia</a>
                        <br><a>Preventive cardiology</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card border-primary">
                  <div class="card-header" role="tab" style="background-color: #366b36b8;" id="heading-19">
                    <h5 class="mb-0">
                      <a class="collapsed accordion-toggle text-left text-white" data-toggle="collapse"
                        data-target="#collapse-19" aria-expanded="false" aria-controls="collapse-19">
                        Neurological Disorders
                      </a>
                    </h5>
                  </div>
                  <div id="collapse-19" class="collapse" role="tabpanel" aria-labelledby="heading-19"
                    data-parent="#accordion-5">
                    <div class="card-body">
                      <div class="text-left">

                        <br><a>Insomnia</a>
                        <br><a>Migraine</a>
                        <br><a>Hemiparesis</a>
                        <br><a>Facial Palsy</a>
                        <br><a>Neuropathy</a>
                        <br><a>Post CVA rehabilitation</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Conditions not treated/admitted -->

<div class="ttm-bgcolor-whiteecolor" *ngIf="section == 'Conditionsnottreatedoradmitted'">
  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">⚠️ Medical Conditions Not Admitted</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container ttm-bgcolor-whiteecolor text-left mt-4">
    <div class="ttm-bgcolor-whiteecolor">
      <div class="max-w-xl mx-auto p-4 rounded-2xl shadow-md">
        <!-- <h2 class="text-xl font-semibold text-red-600 mb-4"></h2> -->
        <ul class="list-disc pl-5 space-y-2 text-gray-700" style="font-size: 20px;">
          <li>Infectious Diseases (e.g., TB, Hepatitis, COVID-19, Herpes)</li>
          <li>Psychiatric Disorders</li>
          <li>Kidney Diseases</li>
          <li>Paralysis</li>
          <li>Epilepsy</li>
          <li>Certain Cardiac Diseases</li>
          <li>Acute Emergencies</li>
          <li>Accidents / Trauma Cases</li>
        </ul>
      </div>
    </div>
  </div>
</div>